/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_DurationInputs */

const en_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURATION`)
};

const fr_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DUREE`)
};

const de_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DAUER`)
};

const it_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURATA`)
};

const ru_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПРОДОЛЖИТЕЛЬНОСТЬ`)
};

const es_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURACIÓN`)
};

const zh_cn2_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期间`)
};

const ja_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_ccsl_export_header_duration = /** @type {(inputs: Ccsl_Export_Header_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURAÇÃO`)
};

/**
* | output |
* | --- |
* | "DURATION" |
*
* @param {Ccsl_Export_Header_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_duration = /** @type {((inputs?: Ccsl_Export_Header_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_duration(inputs)
	if (locale === "de") return de_ccsl_export_header_duration(inputs)
	if (locale === "it") return it_ccsl_export_header_duration(inputs)
	if (locale === "ru") return ru_ccsl_export_header_duration(inputs)
	if (locale === "es") return es_ccsl_export_header_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_duration(inputs)
	if (locale === "ja") return ja_ccsl_export_header_duration(inputs)
	if (locale === "hi") return hi_ccsl_export_header_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_duration(inputs)
	return en_ccsl_export_header_duration(inputs)
});